import { LEGENDS } from "@/data/legends";

export default function HallOfFame() {
  return (
    <div data-testid="hall-of-fame-page" className="px-6 md:px-12 py-16 max-w-7xl mx-auto">
      <div className="font-mono-acc text-xs text-secondary">// STANDING ON SHOULDERS</div>
      <h1 className="font-display text-5xl md:text-7xl mt-3">
        Hall of <span className="text-primary">legends</span>.
      </h1>
      <p className="mt-4 max-w-2xl text-muted-foreground">
        The blueprints. The producers whose fingerprints are on every hi-hat, every 808, every soul chop
        you've ever felt in your chest. Study the greats, then out-work them.
      </p>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 border border-border">
        {LEGENDS.map((l, i) => (
          <article
            key={l.name}
            data-testid={`legend-${l.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className="border-b lg:border-b border-border lg:border-r last:border-r-0 group relative overflow-hidden"
          >
            <div className="aspect-[4/5] overflow-hidden bg-muted relative">
              <img
                src={l.image}
                alt={`Studio vibe representing ${l.name}`}
                loading="lazy"
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-100 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent" />
              <div className="absolute top-4 left-4 font-mono-acc text-[10px] text-secondary bg-background/70 px-2 py-1 border border-secondary">
                #{String(i + 1).padStart(2, "0")}
              </div>
            </div>
            <div className="p-6 border-t border-border">
              <div className="font-mono-acc text-[10px] text-muted-foreground">{l.era}</div>
              <h3 className="font-display text-3xl md:text-4xl mt-2">{l.name}</h3>
              <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{l.tagline}</p>
            </div>
          </article>
        ))}
      </div>

      <p className="mt-10 text-xs font-mono-acc text-muted-foreground max-w-2xl">
        // Photography is royalty-free studio imagery used as tribute — not likenesses of the named producers.
      </p>
    </div>
  );
}
